const CONSENT_KEY = 'testcs.voice.enhanced-publishing-consent.v1'

export const ENHANCED_VOICE_FEATURE = Object.freeze({
  id: 'enhancedVoicePublishing',
  enabled: true,
})

export function loadPublishingConsent(storage = globalThis.localStorage) {
  try {
    const value = JSON.parse(storage?.getItem?.(CONSENT_KEY) || 'null')
    return value?.version === 1 && value?.optedIn === true
  } catch {
    return false
  }
}

export function savePublishingConsent(optedIn, storage = globalThis.localStorage) {
  try {
    storage?.setItem?.(CONSENT_KEY, JSON.stringify({ version: 1, optedIn: optedIn === true }))
    return true
  } catch {
    return false
  }
}
